import { render, staticRenderFns } from "./msDetails.vue?vue&type=template&id=87770302&scoped=true&"
import script from "./msDetails.vue?vue&type=script&lang=js&"
export * from "./msDetails.vue?vue&type=script&lang=js&"
import style0 from "./msDetails.vue?vue&type=style&index=0&id=87770302&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87770302",
  null
  
)

export default component.exports